import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, createSlots as _createSlots, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "custom-table"
};
import { toRefs, ref, watch, onMounted, nextTick } from "vue";
export default {
  __name: 'index',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    columns: Array,
    data: Array,
    height: {
      type: [Number, String],
      default: '100%'
    },
    rowKey: String,
    selections: Array,
    // eg: [row, row, row]
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 20
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 50, 100]
    },
    small: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    background: {
      type: Boolean,
      default: false
    },
    layout: {
      type: String,
      default: () => 'total, sizes, prev, pager, next'
    },
    total: {
      type: [Number, String],
      default: 0
    },
    oddColor: {
      type: Boolean,
      default: true
    },
    isShow: {
      text: Boolean,
      default: true
    },
    headerRow: {
      text: String,
      default: 'left'
    },
    isSelects: {
      type: Boolean,
      default: false
    }
  },
  emits: ['sizeChange', 'currentChange', 'selectionChange', 'onTableSelect', 'sortChange', 'rowClick'],
  setup(__props, {
    emit: __emit
  }) {
    let props = __props;
    const emit = __emit;
    const {
      loading,
      columns,
      data,
      height,
      rowKey,
      selections,
      currentPage,
      total,
      pageSize,
      pageSizes,
      small,
      layout,
      disabled,
      background,
      oddColor
    } = toRefs(props);
    const tableFef = ref();
    const rowClassName = ({
      rowIndex
    }) => oddColor && rowIndex % 2 === 0 ? 'odd' : '';
    const sizeChange = val => {
      emit('sizeChange', val);
    };
    const currentChange = val => {
      emit('currentChange', val);
    };
    const onTableSelect = (rows, val) => {
      emit('onTableSelect', {
        rows,
        val
      });
    };
    const selectionChange = val => {
      emit('selectionChange', val);
    };
    const sortChange = val => {
      emit('sortChange', val);
    };
    const rowClick = val => {
      emit('rowClick', val);
    };
    const dom = ref(null);

    // 勾选的数据
    const dataValue = ref([]);
    watch(() => data.value, (val, preVal) => {
      let {
        selections
      } = props;
      if (selections && selections.length) {
        // 从选择数组中创建一组行键
        const selectedRowKeys = new Set(selections.map(item => item[rowKey.value]));
        // 根据选定的行键过滤行，并直接切换行选择
        setTimeout(() => {
          val.forEach(row => {
            if (selectedRowKeys.has(row[rowKey.value])) {
              tableFef.value.toggleRowSelection(row, true);
            } else {
              tableFef.value.toggleRowSelection(row, false);
            }
          });
        }, 0);
      } else {
        tableFef.value.clearSelection();
      }
    });
    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
        ref_key: "tableFef",
        ref: tableFef,
        data: _unref(data),
        "header-row-style": {
          textAlien: __props.headerRow
        },
        style: {
          width: '100%'
        },
        height: _unref(height),
        "row-key": _unref(rowKey),
        "row-class-name": rowClassName,
        onSelectionChange: selectionChange,
        onSortChange: sortChange,
        onSelect: onTableSelect,
        onRowClick: rowClick,
        "default-expand-all": false,
        "tree-props": {
          children: 'children',
          hasChildren: 'hasChildren'
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(columns), item => {
          return _openBlock(), _createElementBlock(_Fragment, {
            key: item.key
          }, [item.type === 'selection' ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 0,
            selectable: item.selectable,
            "reserve-selection": item.reserveSelection,
            type: item.type,
            fixed: item.fixed,
            width: item.width || 50
          }, null, 8, ["selectable", "reserve-selection", "type", "fixed", "width"])) : item.type === 'expand' ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 1,
            prop: item.prop,
            type: item.type,
            fixed: item.fixed,
            width: item.width || 50
          }, _createSlots({
            _: 2
          }, [item.slot ? {
            name: "default",
            fn: _withCtx(props => [_renderSlot(_ctx.$slots, item.slot, {
              index: props.$index,
              column: props.column,
              row: props.row
            })]),
            key: "0"
          } : undefined]), 1032, ["prop", "type", "fixed", "width"])) : (_openBlock(), _createBlock(_component_el_table_column, {
            key: 2,
            prop: item.prop,
            fixed: item.fixed,
            className: item.className,
            sortable: item.sortable,
            align: item.align,
            label: item.header ? '' : item.label,
            "show-overflow-tooltip": item.showOverflowTooltip,
            width: item.width,
            "min-width": item.minWidth
          }, _createSlots({
            _: 2
          }, [item.header ? {
            name: "header",
            fn: _withCtx(scope => [_renderSlot(_ctx.$slots, item.header, {
              col: item
            })]),
            key: "0"
          } : undefined, item.render ? {
            name: "default",
            fn: _withCtx(scope => [_createTextVNode(_toDisplayString(item.render(scope.$index, scope.row, item.prop)), 1)]),
            key: "1"
          } : item.slot ? {
            name: "default",
            fn: _withCtx(scope => [_renderSlot(_ctx.$slots, item.slot, {
              index: scope.$index,
              column: scope.column,
              row: scope.row
            })]),
            key: "2"
          } : undefined]), 1032, ["prop", "fixed", "className", "sortable", "align", "label", "show-overflow-tooltip", "width", "min-width"]))], 64);
        }), 128))]),
        _: 3
      }, 8, ["data", "header-row-style", "height", "row-key"])), [[_directive_loading, _unref(loading)]]), __props.isShow ? (_openBlock(), _createBlock(_component_el_pagination, {
        key: 0,
        currentPage: _unref(currentPage),
        "page-size": _unref(pageSize),
        "page-sizes": _unref(pageSizes),
        small: _unref(small),
        disabled: _unref(disabled),
        background: _unref(background),
        layout: _unref(layout),
        total: Number(_unref(total)),
        onSizeChange: sizeChange,
        onCurrentChange: currentChange
      }, null, 8, ["currentPage", "page-size", "page-sizes", "small", "disabled", "background", "layout", "total"])) : _createCommentVNode("", true)]);
    };
  }
};